var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-preview absolute bg-white comment-post-bubble shadow-xl border rounded-lg p-2"},[_c('p',{staticClass:"p-2"},[_vm._v(_vm._s(_vm.comment.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }